





















import { Component, Vue } from "vue-property-decorator";
// import { Action, Getter, Mutation } from "vuex-class";
import PartnerList from "@/components/sale/list/PartnerList.vue";

@Component({
  components: { PartnerList },
})
export default class extends Vue {}
